(() => {
  const root = document.querySelector('[data-stillaire-welcome]');
  if (!root) return;

  const enabled = root.dataset.enabled === 'true';
  const delay = Number(root.dataset.delay || 4000);
  const code = root.dataset.code || 'WELCOME10';
  const storageKey = 'stillaire_welcome10_claimed';
  const dismissKey = 'stillaire_welcome10_dismissed';
  const dismissMs = 7 * 24 * 60 * 60 * 1000;

  const formPanel = root.querySelector('[data-welcome-form-panel]');
  const successPanel = root.querySelector('[data-welcome-success-panel]');
  const form = root.querySelector('form');
  const errorEl = root.querySelector('[data-welcome-error]');
  const codeEl = root.querySelector('[data-welcome-code]');
  const copyBtn = root.querySelector('[data-welcome-copy]');
  const copiedEl = root.querySelector('[data-welcome-copied]');
  const closeEls = root.querySelectorAll('[data-welcome-close]');

  const inDesignMode = Boolean(window.Shopify && window.Shopify.designMode);

  // Keep closed until we decide to open (avoids flash)
  root.hidden = true;

  function wasDismissedRecently() {
    try {
      const raw = localStorage.getItem(dismissKey);
      if (!raw) return false;
      return Date.now() - Number(raw) < dismissMs;
    } catch (e) {
      return false;
    }
  }

  function alreadyClaimed() {
    try {
      return localStorage.getItem(storageKey) === '1';
    } catch (e) {
      return false;
    }
  }

  function openPopup() {
    root.hidden = false;
    root.classList.add('is-open');
    document.body.classList.add('stillaire-welcome-open');
    const input = root.querySelector('input[type="email"]');
    if (input) input.focus({ preventScroll: true });
  }

  function closePopup(markDismissed) {
    root.hidden = true;
    root.classList.remove('is-open');
    document.body.classList.remove('stillaire-welcome-open');
    if (markDismissed) {
      try {
        localStorage.setItem(dismissKey, String(Date.now()));
      } catch (e) {}
    }
  }

  function showSuccess() {
    if (formPanel) formPanel.hidden = true;
    if (successPanel) successPanel.hidden = false;
    if (codeEl) codeEl.textContent = code;
    try {
      localStorage.setItem(storageKey, '1');
      localStorage.removeItem(dismissKey);
    } catch (e) {}
  }

  closeEls.forEach((el) => {
    el.addEventListener('click', () => closePopup(true));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden) closePopup(true);
  });

  if (copyBtn) {
    copyBtn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(code);
        if (copiedEl) {
          copiedEl.hidden = false;
          window.setTimeout(() => {
            copiedEl.hidden = true;
          }, 1800);
        }
      } catch (e) {
        if (codeEl) {
          const range = document.createRange();
          range.selectNodeContents(codeEl);
          const selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    });
  }

  if (form) {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }

      const emailInput = form.querySelector('input[type="email"]');
      const email = emailInput ? emailInput.value.trim() : '';
      if (!email || !email.includes('@')) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = 'Please enter a valid email address.';
        }
        return;
      }

      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      try {
        const body = new FormData(form);
        await fetch(form.action || '/contact', {
          method: 'POST',
          body,
          headers: {
            Accept: 'application/json',
          },
        });
        showSuccess();
      } catch (e) {
        showSuccess();
      } finally {
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  }

  if (!enabled && !inDesignMode) return;
  if (!inDesignMode && (alreadyClaimed() || wasDismissedRecently())) return;

  if (inDesignMode) {
    openPopup();
    return;
  }

  window.setTimeout(openPopup, Number.isFinite(delay) ? delay : 4000);
})();
